(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    // Matches --gallery-fade: how long the outgoing slide stays visible under the incoming one.
    const FADE_MS = 700;
    const SWIPE_THRESHOLD = 40;

    /**
     * Product image carousel. Autoplay is off for reduced motion and in the theme editor; any
     * manual navigation (thumbnail, arrow, swipe, key, variant change) stops it until the shopper
     * presses Play. Hover, focus inside, hidden tabs and offscreen galleries pause it temporarily.
     * Only the active slide (plus the next one while autoplay runs) is displayed, so lazy images
     * for the rest are never requested.
     */
    class ProductGallery extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-image-id]')];
        if (!this.slides.length) return;
        this.listeners?.abort();
        this.listeners = new AbortController();
        const { signal } = this.listeners;
        this.stage = this.querySelector('[data-gallery-stage]');
        this.thumbnails = [...this.querySelectorAll('[data-thumbnail]')];
        this.counter = this.querySelector('[data-image-counter]');
        this.playButton = this.querySelector('[data-gallery-play]');
        this.progress = this.querySelector('[data-gallery-progress]');
        this.interval = Number(this.dataset.interval) || 5000;
        this.index = -1;
        this.playing = false;
        this.hovered = false;
        this.focused = false;
        this.visible = true;
        this.dataset.enhanced = '';
        this.select(this.dataset.selectedImage, { animate: false });
        if (this.slides.length < 2) return;

        this.querySelectorAll('[data-gallery-controls], [data-image-step]').forEach((node) => { node.hidden = false; });
        this.addEventListener('click', (event) => this.onClick(event), { signal });
        this.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') this.setPause('hovered', true); }, { signal });
        this.addEventListener('pointerleave', (event) => { if (event.pointerType === 'mouse') this.setPause('hovered', false); }, { signal });
        this.addEventListener('focusin', () => this.setPause('focused', true), { signal });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.setPause('focused', false);
        }, { signal });
        this.stage.addEventListener('keydown', (event) => this.onKeydown(event), { signal });
        this.stage.addEventListener('pointerdown', (event) => this.onPointerDown(event), { signal });
        this.stage.addEventListener('pointerup', (event) => this.onPointerUp(event), { signal });
        this.stage.addEventListener('pointercancel', () => { this.swipe = null; }, { signal });
        // A swipe ends on the slide link; do not also open the image in a new tab.
        this.stage.addEventListener('click', (event) => {
          if (!this.swiped) return;
          this.swiped = false;
          event.preventDefault();
          event.stopPropagation();
        }, { signal, capture: true });
        document.addEventListener('visibilitychange', () => this.schedule(), { signal });
        this.observer = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.schedule();
        });
        this.observer.observe(this);

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.setPlaying(!reducedMotion && !window.Shopify?.designMode);
      }

      disconnectedCallback() {
        this.listeners?.abort();
        this.observer?.disconnect();
        clearTimeout(this.timer);
        clearTimeout(this.cleanup);
      }

      onClick(event) {
        const thumbnail = event.target.closest('[data-thumbnail]');
        if (thumbnail) {
          event.preventDefault();
          this.select(thumbnail.dataset.thumbnail, { manual: true });
          return;
        }
        const step = event.target.closest('[data-image-step]');
        if (step) {
          this.goTo(this.index + Number(step.dataset.imageStep), { manual: true });
          return;
        }
        if (event.target.closest('[data-gallery-play]')) {
          // An explicit Play outranks hover/focus pauses until the pointer or focus re-enters.
          if (!this.playing) {
            this.hovered = false;
            this.focused = false;
          }
          this.setPlaying(!this.playing);
        }
      }

      onKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const forward = (event.key === 'ArrowRight') !== this.isRtl();
        this.goTo(this.index + (forward ? 1 : -1), { manual: true });
      }

      onPointerDown(event) {
        if (event.pointerType === 'mouse' || !event.isPrimary) return;
        this.swipe = { x: event.clientX, y: event.clientY };
        this.swiped = false;
      }

      onPointerUp(event) {
        if (!this.swipe) return;
        const dx = event.clientX - this.swipe.x;
        const dy = event.clientY - this.swipe.y;
        this.swipe = null;
        if (Math.abs(dx) < SWIPE_THRESHOLD || Math.abs(dx) < Math.abs(dy)) return;
        this.swiped = true;
        // Dragging toward the inline start reveals the next image (left in LTR, right in RTL).
        const forward = (dx < 0) !== this.isRtl();
        this.goTo(this.index + (forward ? 1 : -1), { manual: true });
      }

      isRtl() {
        return getComputedStyle(this).direction === 'rtl';
      }

      /** Public: shows an image by ID (used for variant changes). Unknown IDs fall back to the first image. */
      select(id, options = {}) {
        const index = this.slides.findIndex((slide) => slide.dataset.imageId === String(id));
        this.goTo(Math.max(index, 0), options);
      }

      goTo(target, { animate = true, manual = false } = {}) {
        const count = this.slides.length;
        const index = ((target % count) + count) % count;
        if (manual) {
          this.playing = false;
          this.counter?.setAttribute('aria-live', 'polite');
        }
        if (index !== this.index) {
          const previous = this.slides[this.index];
          const next = this.slides[index];
          const hadFocus = this.stage.contains(document.activeElement);
          this.index = index;
          this.preloaded = null;
          clearTimeout(this.cleanup);
          this.stage.classList.toggle('is-instant', !animate);
          next.hidden = false;
          // Commit the hidden starting state so the fade actually runs.
          if (animate) void next.offsetWidth;
          this.slides.forEach((slide) => {
            slide.classList.toggle('is-active', slide === next);
            slide.classList.toggle('is-leaving', animate && slide === previous);
            slide.inert = slide !== next;
          });
          if (hadFocus) next.focus({ preventScroll: true });
          if (animate) this.cleanup = setTimeout(() => this.prune(), FADE_MS);
          else this.prune();
          this.syncControls(animate);
        }
        this.schedule();
        if (manual) this.syncPlayButton();
      }

      /** Keeps only the active slide (and the preloaded next one) displayed. */
      prune() {
        this.slides.forEach((slide, i) => {
          slide.classList.remove('is-leaving');
          slide.hidden = i !== this.index && slide !== this.preloaded;
        });
      }

      syncControls(animate) {
        this.thumbnails.forEach((thumbnail) => {
          const current = thumbnail.dataset.thumbnail === this.slides[this.index].dataset.imageId;
          if (!current) {
            thumbnail.removeAttribute('aria-current');
            return;
          }
          thumbnail.setAttribute('aria-current', 'true');
          this.revealThumbnail(thumbnail, animate);
        });
        if (this.counter) this.counter.textContent = this.dataset.imageCount.replace('[current]', this.index + 1).replace('[total]', this.slides.length);
      }

      // Scrolls only the thumbnail strip; scrollIntoView would also scroll the page during autoplay.
      revealThumbnail(thumbnail, animate) {
        const strip = thumbnail.parentElement;
        if (strip.scrollWidth <= strip.clientWidth) return;
        const stripBox = strip.getBoundingClientRect();
        const box = thumbnail.getBoundingClientRect();
        if (box.left >= stripBox.left && box.right <= stripBox.right) return;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        strip.scrollBy({ left: box.left - stripBox.left - (stripBox.width - box.width) / 2, behavior: animate && !reducedMotion ? 'smooth' : 'auto' });
      }

      setPlaying(playing) {
        this.playing = playing;
        this.syncPlayButton();
        this.schedule();
      }

      syncPlayButton() {
        this.playButton?.setAttribute('aria-pressed', String(!this.playing));
      }

      setPause(reason, paused) {
        this[reason] = paused;
        this.schedule();
      }

      /** (Re)starts the autoplay countdown when nothing is holding it, otherwise stops it. */
      schedule() {
        clearTimeout(this.timer);
        this.timer = null;
        if (this.slides.length < 2) return;
        const running = this.playing && !this.hovered && !this.focused && this.visible && !document.hidden;
        this.toggleAttribute('data-running', running);
        // Announce image changes only when the shopper drives them, not on every autoplay tick.
        this.counter?.setAttribute('aria-live', running ? 'off' : 'polite');
        if (this.progress) {
          this.progress.style.animation = 'none';
          void this.progress.offsetWidth;
          this.progress.style.animation = '';
        }
        if (!running) return;
        this.preload((this.index + 1) % this.slides.length);
        this.timer = setTimeout(() => this.goTo(this.index + 1), this.interval);
      }

      // Displays the upcoming slide invisibly so its image is ready before it fades in.
      preload(index) {
        const slide = this.slides[index];
        if (this.preloaded === slide) return;
        this.preloaded = slide;
        slide.hidden = false;
        slide.inert = true;
        const image = slide.querySelector('img');
        if (image) image.loading = 'eager';
      }
    }

    if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["promo-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
    const MINUTE = 60000;

    /** Keeps the server-rendered countdown current; updates on each minute boundary. */
    class PromoCountdown extends HTMLElement {
      connectedCallback() {
        this.end = Number(this.dataset.end) || 0;
        this.values = Object.fromEntries([...this.querySelectorAll('[data-countdown]')].map((node) => [node.dataset.countdown, node]));
        this.tick();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      tick() {
        const remaining = Math.max(0, this.end - Date.now());
        const totalMinutes = Math.ceil(remaining / MINUTE);
        const pad = (value) => String(value).padStart(2, '0');
        this.values.days.textContent = Math.floor(totalMinutes / 1440);
        this.values.hours.textContent = pad(Math.floor((totalMinutes % 1440) / 60));
        this.values.minutes.textContent = pad(totalMinutes % 60);
        if (remaining > 0) this.timer = setTimeout(() => this.tick(), remaining % MINUTE || MINUTE);
      }
    }

    if (!customElements.get('promo-countdown')) customElements.define('promo-countdown', PromoCountdown);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["promo-price"] && !Shopify.designMode) return;
  try {
    (() => {
    /** Swaps the campaign price back to the normal price when the campaign ends. */
    class PromoPrice extends HTMLElement {
      connectedCallback() {
        const end = Number(this.dataset.end) || 0;
        if (!end) return;
        const remaining = end - Date.now();
        if (remaining <= 0) {
          this.expire();
          return;
        }
        // setTimeout overflows past ~24.8 days; a page is not kept open that long.
        if (remaining < 2 ** 31) this.timer = setTimeout(() => this.expire(), remaining);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      expire() {
        const fallback = this.querySelector('template[data-promo-fallback]');
        if (fallback) this.replaceWith(fallback.content.cloneNode(true));
      }
    }

    if (!customElements.get('promo-price')) customElements.define('promo-price', PromoPrice);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["promo-status"] && !Shopify.designMode) return;
  try {
    (() => {
    /**
     * Wraps a scheduled promotion. Liquid already hides inactive campaigns, but a cached
     * page can outlive the end date, so this hides the campaign once its end time passes
     * (on load, and live while the page stays open). Theme editor previews stay visible.
     */
    class PromoCampaign extends HTMLElement {
      connectedCallback() {
        const end = Number(this.dataset.end) || 0;
        if (!end || this.hasAttribute('data-preview')) return;
        const remaining = end - Date.now();
        if (remaining <= 0) {
          this.hidden = true;
          return;
        }
        // setTimeout overflows past ~24.8 days; a page is not kept open that long.
        if (remaining < 2 ** 31) this.timer = setTimeout(() => { this.hidden = true; }, remaining);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }
    }

    if (!customElements.get('promo-campaign')) customElements.define('promo-campaign', PromoCampaign);
  })();
  } catch(e) { console.error(e); }
})();

})();
